export { default } from "./ModificaCategorias";
